import React, {useRef, useState} from 'react';
import DataGrid from "../../../controls/DataGrid";
import {withStyles} from "@material-ui/core/styles";

const styles = {
  bookingQueueFormDimensionsCell: {
    fontSize: 12,
    paddingLeft: "3px !important",
    paddingRight: "3px !important",
  },
  bookingQueueFormDimensionsHeader: {
    fontSize: 12,
    paddingLeft: "4px !important",
    paddingRight: "4px !important",
  }
};


const BookingSummaryGrid = (_props) => {
  const props = {
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit||false,
  });

  const { classes } = props;

  const dataGridRef = useRef();
  const destinations = props.destinations;
  const totals = props.totals

  const getColumns = (props) => {
    const baseColumn = {
      // options: {
      //   cellClass: classes.bookingQueueFormDimensionsCell,
      //   headerClass: classes.bookingQueueFormDimensionsHeader,
      // },
      editable: state.canEdit,
    };

    return [
      {
        ...baseColumn,
        headerName: "Destination",
        field: "destination",
        width: 120,
      },
      {
        ...baseColumn,
        headerName: "Actual Weight",
        field: "weight",
        width: 140,
        type: "rightAligned",
      },
      {
        ...baseColumn,
        headerName: "Volume",
        field: "volume",
        width: 140,
        type: "numericColumn",
      },
      {
        ...baseColumn,
        headerName: "Chargeable Weight",
        field: "chargeableWeight",
        width: 180,
        type: "numericColumn",
      },
      {
        ...baseColumn,
        headerName: "Revenue ($)",
        field: "revenue",
        width: 120,
        type: "numericColumn",
        flex: 1,
      },
      {
        ...baseColumn,
        headerName: "Yield ($)",
        field: "yield",
        type: "numericColumn",
        flex: 1,
      },
    ];
  };

  return (
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="Booking Summary"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={destinations}
        summaryRow={totals}
        height={props.height||`calc(100vh - ${(290)}px)`}
        options={{
          singleClickEdit: true,
          editType:'fullRow',
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
            menuTabs: []
          }
        }}
      />
    </div>
  );

}

export default withStyles(styles)(BookingSummaryGrid);